let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4gFRu")).then(() => parcelRequire('i3AK8'));